const fontSizeOnClick = () => {
	const button = document.getElementById("fontsize");

	const fontSizeToggle = () => {
		const container = document.getElementsByTagName("html")[0];
		container.classList.toggle('fontsize');
		button.classList.toggle('active');

		if ( !document.cookie.includes('FontSize=true') ) {
			document.cookie = "FontSize=true";
		} else {
			document.cookie = "FontSize=false";
		}
	}
	
	button.addEventListener("click", fontSizeToggle, false);
}

fontSizeOnClick();

const fontSizeOnLoad = () => {
	const button = document.getElementById("fontsize");

	if ( document.cookie.includes('FontSize=true') ) {
		const container = document.getElementsByTagName("html")[0];
		container.classList.add('fontsize')
		button.classList.add('active')
	}
}

fontSizeOnLoad();


const contrastOnClick = () => {
	const button = document.getElementById("contrast");

	const contrastToggle = () => {
		const container = document.getElementsByTagName("html")[0];
		container.classList.toggle('contrast');
		button.classList.toggle('active');

		if ( !document.cookie.includes('Contrast=true') ) {
			document.cookie = "Contrast=true";
		} else {
			document.cookie = "Contrast=false";
		}
	}
	
	button.addEventListener("click", contrastToggle, false);
}

contrastOnClick();

const contrastOnLoad = () => {
	const button = document.getElementById("contrast");

	if ( document.cookie.includes('Contrast=true') ) {
		const container = document.getElementsByTagName("html")[0];
		container.classList.add('contrast')
		button.classList.add('active')
	}
}

contrastOnLoad();


const cookieOnLoad = () => {
	if ( !document.cookie.includes('CookieConsent=true') ) {
		const container = document.getElementById("cookies");
		container.classList.add('show')
	}
}

cookieOnLoad();

const cookieOnClick = () => {
	const setCookie = () => {
		const container = document.getElementById("cookies");
		container.classList.remove('show');
		document.cookie = "CookieConsent=true";
	}

	const button = document.getElementById("setCookie");
	button.addEventListener("click", setCookie, false);
}

cookieOnClick();

const menuOnClick = () => {
	const button = document.getElementById("menuToggle");

	const menuToggle = () => {
		const body = document.getElementsByTagName("body")[0];
		const container = document.getElementById("nav");
		container.classList.toggle('active')
		body.classList.toggle('menuActive')
		button.classList.toggle('active')
	}

	
	button.addEventListener("click", menuToggle, false);
}

menuOnClick();

const searchOnClick = () => {
	const searchToggle = () => {
		const container = document.getElementById("search");
		const searchInput = document.getElementById("search-input");
		container.classList.toggle('active');
		searchInput.focus();
	}

	const button = document.getElementById("searchToggle");
	button.addEventListener("click", searchToggle, false);
}

searchOnClick();